export default "__VITE_ASSET__CWzFuvwb__"